import founder from "@/assets/optimized-images/co-founder.png";
import { cardInfos } from "../../components/Data/datas";
import { IoPeopleOutline } from "react-icons/io5";
import { MdOutlinePlayLesson } from "react-icons/md";
import Card3 from "../Academy/Courses_Cards/Card3";
import {
  academyPath,
  learningToolsPath,
  qiraatPath,
  quranPath,
} from "../../components/routes/path";

const InstructorOwner = () => {
  return (
    <div className="bg-[#F7F7F7] p-10 sm:py-20 sm:px-14 font-[Roboto]">
      <div className="grid sm:grid-cols-[1fr_auto] gap-20">
        <div className="bg-white p-10 flex flex-col gap-5 sm:p-24">
          <h2 className="font-imter font-medium text-3xl"> Instructor</h2>
          <div className="grid gap-20">
            <div className="flex gap-5 items-center justify-center w-full font-[Roboto] p-5  border  rounded">
              <img src={founder} alt="" className="w-33 sm:w-50" />
              <div className="space-y-1 sm:space-y-3">
                <p className="text-2xl font-bold">MUQRI</p>
                <p className="text-sm sm:text-[16px] leading-6 sm:leading-10 w-full">
                  we'll serve You to get The best learning Experience. Send a
                  Whatsapp DM | +234 815 378 3287
                </p>
                <div className="flex flex-col sm:flex-row justify-between">
                  <div className="flex gap-2">
                    <MdOutlinePlayLesson className="mt-1" />
                    <p className="text-sm">{cardInfos.length} Courses</p>
                  </div>
                  <div className="flex gap-2">
                    <IoPeopleOutline className="mt-1" />
                    <p className="text-sm">3000+ Students</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid sm:grid-cols-2 gap-10">
              {cardInfos.map((cardInfo) => (
                <Card3
                  key={cardInfo.id}
                  {...cardInfo}
                  toCategory={
                    cardInfo.bookCaterory == "QUR'AN"
                      ? quranPath
                      : cardInfo.bookCaterory == "Learning Tools"
                      ? learningToolsPath
                      : cardInfo.bookCaterory == "Key Principles of Qira’at" &&
                        qiraatPath
                  }
                  to={`${academyPath}/${cardInfo.id}`}
                />
              ))}
            </div>
          </div>
        </div>
        <div className="w-90 sm:w-full">
          <div className="bg-white p-10">
            <label htmlFor="search">Search</label>
            <div className="flex gap-2">
              <input
                type="text"
                className="bg-[#cedce1] p-2 border-none rounded outline-none w-full"
              />
              <button className="bg-[#004C97] text-white hover:bg-white hover:text-[#3b76db] rounded-md  py-2 px-5">
                Search
              </button>
            </div>
          </div>
          <div className="bg-white p-10"></div>
          <div className="bg-white p-10"></div>
        </div>
      </div>
    </div>
  );
};

export default InstructorOwner;
